"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _utils = require("./utils");
require("./HoverText.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var HoverText = function HoverText(_ref) {
  var children = _ref.children,
    content = _ref.content,
    placement = _ref.placement,
    trigger = _ref.trigger,
    stylingOptions = _ref.stylingOptions,
    hideOnClick = _ref.hideOnClick,
    html = _ref.html,
    scrollElement = _ref.scrollElement,
    parentClass = _ref.parentClass;
  var element = document.createElement("div");
  var tooltipId;
  var counter = 0;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    tooltipCont = _useState2[0],
    setTooltipCont = _useState2[1];
  (0, _react.useEffect)(function () {
    (0, _utils.validateProps)(placement, content);
    return function () {
      tooltipId = JSON.parse(localStorage.getItem("hoverTooltipId"));
      if (tooltipId) {
        (0, _utils.removeTooltip)(tooltipId);
      }
    };
  }, []);
  var handleHover = function handleHover(e) {
    if (trigger === "click") return;
    tooltipId = (0, _utils.generateNewTooltipId)();
    localStorage.setItem("hoverTooltipId", JSON.stringify(tooltipId));
    (0, _utils.displayTooltip)(e, element, content, tooltipId, placement, stylingOptions, html, scrollElement, parentClass);
  };
  var handleClick = function handleClick(e) {
    if (trigger !== "click") return;
    if (_utils.tooltipsData.includes(tooltipId) === false && !hideOnClick) {
      counter = 0;
    }
    counter++;
    if (counter === 1) {
      tooltipId = (0, _utils.generateNewTooltipId)();
      if (html) {
        setTooltipCont((0, _utils.displayTooltip)(e, element, content, tooltipId, placement, stylingOptions, html, scrollElement, parentClass));
        var tableRow = e.target.parentElement.parentElement;
        tableRow.classList.add("table-row-tooltip");
        tableRow.setAttribute("id", "tooltip-".concat(tooltipId));
      }
      if (!hideOnClick) {
        _utils.tooltipsData.push(tooltipId);
      }
    }
    if (counter > 1 && hideOnClick) {
      (0, _utils.removeTooltip)(tooltipId);
      counter = 0;
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (trigger === "click") return;
    tooltipId = JSON.parse(localStorage.getItem("hoverTooltipId"));
    (0, _utils.removeTooltip)(tooltipId);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/(0, _react.cloneElement)(children, _objectSpread(_objectSpread({}, children.props), {}, {
    onMouseOver: handleHover,
    onMouseOut: handleMouseLeave
  }, trigger && trigger === "click" && {
    onClick: function onClick(e) {
      handleClick(e);
      children.props.onClick && children.props.onClick(e);
    }
  })), tooltipCont && /*#__PURE__*/(0, _reactDom.createPortal)(content, tooltipCont));
};
var _default = HoverText;
exports["default"] = _default;